import React, { useState, useEffect } from 'react';

import { Form, Button, Space, Select, Row, Col } from 'antd';

import emiter, { EVENT_CARRENTAL_STORE_RATING, EVENT_CARRENTAL_STORE_TEXT } from '../../../../events';
import request from "../../../../request";
import { API_STORE_SCORE_INFO, API_VEHICLE_GET_STORE } from "../../../../hooks/carRental/_";
import { _APIS } from "../../../../apis";
import { jsonParseData } from "../../../../utils";


interface PropsType {
  enums?: any;
}

const SPStoreRatingForm: React.FC<PropsType> = (props) => {
  const searchButtonText = '搜索';
  const clearButtonText = '清空';
  const searchFormFields = {
    mendianmingcheng: {name: 'store_code', label: '门店名称', required: false, message: '门店名称错误!', placeholder: '请输入门店名称'},
  };

  const [searchForm] = Form.useForm();

  const onSearchFormReset = () => {
    searchForm.resetFields();
    onSearchFormFinish()
  };

  const onSearchFormFinish = () => {
    request({
      url: API_STORE_SCORE_INFO,
      method: 'GET',
      params:searchForm.getFieldsValue()
    }).then((res: any) => {
      const { errno } = res || {};
      if (errno === 0) {
        emiter.emit(EVENT_CARRENTAL_STORE_RATING, {...res?.data})
      }
    }).catch(()=>{
      emiter.emit(EVENT_CARRENTAL_STORE_RATING, {})
    });
  };

  // 请求商家分配置文案
  const getSupplierScoreText= () => {
    request({
      url: _APIS.PRODUCT_PRICE.COMMON.CONFIG,
      method: 'GET',
      params: {
        config_name: 'supplier_score_config',
        param_name: 'supplier_score_text',
      }
    }).then((res: any) => {
      const {errno} = res || {};
      if (errno === 0) {
        emiter.emit(EVENT_CARRENTAL_STORE_TEXT, jsonParseData(res?.data?.supplier_score_text, {}))
      }
    });

  }

  const [storeList, setStoreList] = useState([]);

  const getStoreList = () => {
    request({
      url: API_VEHICLE_GET_STORE,
      method: 'GET',
    }).then((res: any) => {
      setStoreList(res.data);
      searchForm.setFieldValue('store_code',res.data[0].store_code)
      onSearchFormFinish()
    });
  };

  useEffect(() => {
    getSupplierScoreText()
    getStoreList();
  }, [])

  const formItemStyle: React.CSSProperties = { display: 'block' };

  return (
    <div style={{margin:'16px 0 0'}}>
      <Form form={searchForm} onFinish={onSearchFormFinish}>
        <Row gutter={24}>
          <Col span={8}>
            <Form.Item
                style={formItemStyle}
                name={searchFormFields?.mendianmingcheng.name}
                label={searchFormFields?.mendianmingcheng.label}
                rules={[
                  {
                    required: searchFormFields?.mendianmingcheng.required,
                    message: searchFormFields?.mendianmingcheng.message,
                  },
                ]}
            >
              <Select
                  placeholder={searchFormFields?.mendianmingcheng.placeholder}
                  allowClear
                  showSearch
                  optionFilterProp="children"
                  style={{ width: '100%' }}
              >
                {storeList &&
                    storeList.map((item: any) => (
                        <Select.Option value={item.store_code} key={item.store_code}>
                          {item.store_name}
                        </Select.Option>
                    ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Space size="small">
              <Button type="primary" onClick={onSearchFormFinish}>{searchButtonText}</Button>
              <Button onClick={onSearchFormReset}>{clearButtonText}</Button>
            </Space>
          </Col>
        </Row>
      </Form>
      </div>
  );
};

export default SPStoreRatingForm;

